export const DateFormat = new global.Intl.DateTimeFormat('en-US', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
}).format;

export const dateToHumanString = (input) => {
  if (!input) return '';
  var date;
  if(typeof(input) === 'string') {
    date = new Date(input)
  } else if(typeof(input) === 'number') {
    date = new Date(input * 1000)
  } else {
    date = input
  }
  return DateFormat(date);
  // return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
};




// WEBPACK FOOTER //
// ./src/utils/DateUtils.js